module.exports = __webpack_public_path__ + "img/notes-reconcile.57b1f45a.svg";